import * as React from 'react';
import * as styles from './styles.css';

interface IPromosWrapperProps {
  children: React.ReactNode;
  controls: React.ReactNode;
}

export function PromosWrapper({ children, controls }: IPromosWrapperProps) {
  return (
    <div className={styles['container']}>
      {controls}
      {children}
    </div>
  );
}
